export default [
  {
    title: 'Dashboard',
    route: 'home',
    icon: 'HomeIcon',
    resource: 'APP_DASHBOARD',
    action: 'read',
  },
  {
    title: 'Site Genel',
    route: null,
    icon: 'GlobeIcon',
    children: [
      {
        title: 'Site Menü',
        route: 'SiteMenus',
        resource: 'ADMIN_SITE_MENU',
        action: 'read',
      },
      {
        title: 'Carousel',
        route: 'Carousel',
        resource: 'ADMIN_CAROUSEL',
        action: 'read',
      },
      {
        title: 'Sabit İçerikler',
        route: 'Contents',
        resource: 'ADMIN_CONTENTS',
        action: 'read',
      },
    ],
  },
  {
    title: 'Kurumsal',
    route: null,
    icon: 'FileTextIcon',
    children: [
      {
        title: 'Anasayfa',
        route: 'HomePage',
        resource: 'ADMIN_HOME_PAGE',
        action: 'read',
      },
      {
        title: 'Tarihçe & Hakkımızda',
        route: 'About',
        resource: 'ADMIN_ABOUT',
        action: 'read',
      },
      {
        title: 'Deneyim',
        route: 'AboutCounters',
        resource: 'ADMIN_ABOUT_COUNTERS',
        action: 'read',
      },
      {
        title: 'Sertifikalar',
        route: 'Certificates',
        resource: 'ADMIN_CERTIFICATES_LIST',
        action: 'read',
      },
      {
        title: 'İletişim',
        route: 'Contacts',
        resource: 'ADMIN_CONTACT',
        action: 'read',
      },
      {
        title: 'Referanslar',
        route: 'References',
        resource: 'ADMIN_REFERENCES',
        action: 'read',
      },
    ],
  },
  {
    title: 'Sosyal Sorumluluk',
    route: 'CorporatePolicies',
    icon: 'GlobeIcon',
    resource: 'ADMIN_CORPORATE_POLICIES',
    children: [
      {
        title: 'Oluştur',
        route: 'CorporatePoliciesAdd',
        resource: 'ADMIN_CORPORATE_POLICIES',
        action: 'read',
      },
      {
        title: 'Listele',
        route: 'CorporatePolicies',
        resource: 'ADMIN_CORPORATE_POLICIES',
        action: 'read',
      },
      {
        title: 'Kategoriler',
        route: 'CorporatePoliciesCategories',
        resource: 'ADMIN_CORPORATE_POLICIES_CATEGORIES',
        action: 'read',
      },
    ],
    action: 'read',
  },
  {
    title: 'Laboratuvar',
    route: 'Services',
    icon: 'BoxIcon',
    children: [
      {
        title: 'Hakkımızda',
        route: 'Lab',
        resource: 'ADMIN_LAB',
        action: 'read',
      },
      {
        title: 'Hizmet Şartlarımız',
        route: 'LaboratoryServiceTerms',
        resource: 'ADMIN_LAB',
        action: 'read',
      },
      {
        title: 'Laboratuvar Politikamız',
        route: 'LaboratoryPolicy',
        resource: 'ADMIN_LAB',
        action: 'read',
      },
      {
        title: 'Hizmetlerimiz',
        route: 'LaboratoryServices',
        resource: 'ADMIN_LAB',
        action: 'read',
      },
      {
        title: 'Eğitimlerimiz',
        route: 'LaboratoryEducations',
        resource: 'ADMIN_LAB',
        action: 'read',
      },
      {
        title: 'Formlar',
        route: 'LaboratoryForms',
        resource: 'ADMIN_LAB',
        action: 'read',
      },
    ],
  },
  {
    title: 'Ürünler',
    route: 'Products',
    icon: 'LayersIcon',
    children: [
      {
        title: 'Oluştur',
        route: 'ProductAdd',
        resource: 'ADMIN_PRODUCTS',
        action: 'read',
      },
      {
        title: 'Listele',
        route: 'Products',
        resource: 'ADMIN_PRODUCTS',
        action: 'read',
      },
      {
        title: 'Kategoriler',
        route: 'ProductCategories',
        resource: 'ADMIN_PRODUCT_CATEGORIES',
        action: 'read',
      },
      {
        title: 'Tanımlar',
        route: 'ProductConfig',
        resource: 'ADMIN_PRODUCT_CONFIG',
        action: 'read',
      },
    ],
  },
  {
    title: 'Blog',
    route: 'Blog',
    icon: 'BookIcon',
    children: [
      {
        title: 'Oluştur',
        route: 'BlogAdd',
        resource: 'ADMIN_BLOG',
        action: 'read',
      },
      {
        title: 'Listele',
        route: 'Blog',
        resource: 'ADMIN_BLOG',
        action: 'read',
      },
      {
        title: 'Kategoriler',
        route: 'BlogCategories',
        resource: 'ADMIN_BLOG_CATEGORIES',
        action: 'read',
      },
    ],
  },
  {
    title: 'Web Talepleri',
    route: 'Webforms',
    icon: 'MessageSquareIcon',
    children: [
      {
        title: 'Listele',
        route: 'Webforms',
        resource: 'ADMIN_WEBFORMS',
        action: 'read',
      },
    ],
  },
  {
    title: 'Modüller',
    route: null,
    icon: 'CodesandboxIcon',
    children: [
      {
        title: 'Lead Form',
        route: 'ModLeads',
        resource: 'ADMIN_MODULES',
        action: 'read',
      },
      {
        title: 'Sosyal Medya',
        route: 'Socialmedia',
        resource: 'ADMIN_MODULES',
        action: 'read',
      },
      {
        title: 'İletişim Adresleri',
        route: 'FooterContacts',
        resource: 'ADMIN_MODULES',
        action: 'read',
      },
    ],
  },
  {
    title: 'Dil Çeviri',
    route: null,
    icon: 'FlagIcon',
    children: [
      {
        title: 'Çeviri Listesi',
        route: 'Translate',
        resource: 'ADMIN_TRANSLATE',
        action: 'read',
      },
    ],
  },
  {
    title: 'Kullanıcılar',
    route: 'Users',
    icon: 'UsersIcon',
    children: [
      {
        title: 'Kullanıcılar',
        route: 'Users',
        resource: 'ADMIN_USERS',
        action: 'read',
      },
      {
        title: 'Kullanıcı Yetkileri',
        route: 'UserTypes',
        resource: 'ADMIN_USER_TYPES',
        action: 'read',
      },
    ],
  },
  {
    title: 'Ayarlar',
    route: null,
    icon: 'SettingsIcon',
    children: [
      {
        title: 'Genel Yapılandırma',
        route: 'Configs',
        resource: 'ADMIN_CONFIG',
        action: 'read',
      },
      {
        title: 'SEO Yapılandırma',
        route: 'Components',
        resource: 'ADMIN_CONFIG',
        action: 'read',
      },
      {
        title: 'SMTP',
        route: 'Smtp',
        resource: 'ADMIN_SMTP',
        action: 'read',
      },
      {
        title: 'Form Departmanlar',
        route: 'WebformDepartments',
        resource: 'ADMIN_WEBFORM_DEPARTMENTS',
        action: 'read',
      },
      {
        title: 'Önbellek Yönetimi',
        route: 'CacheParams',
        resource: 'ADMIN_CONFIG',
        action: 'read',
      },
    ],
  },
]
